import React from "react";
import classNames from "classnames";

type PropsTypeButtonCheckbox = {
  classNameLabel?: string;
  classNameText?: string;
  text: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  id: string;
  checked?: boolean;
};

function ButtonCheckbox({
  classNameLabel,
  classNameText,
  text,
  onChange,
  id,
  checked = false,
}: PropsTypeButtonCheckbox) {
  return (
    <label
      htmlFor={id}
      className={classNames(classNameLabel, "flex cursor-pointer")}
    >
      <span className={classNames(classNameText)}>{text}</span>
      <input
        defaultChecked={checked}
        className='peer hidden'
        id={id}
        type='checkbox'
        onChange={onChange}
      />
      <span className='before:delay-0 delay-0 dark:bg-grey-dark-light relative h-[25px] w-[40px] rounded-xl bg-grey-light transition-all duration-300 ease-in-out before:absolute before:top-0.5 before:left-0.5 before:h-[21px] before:w-[21px] before:rounded-full before:bg-white before:transition-all before:duration-300 before:ease-in-out peer-checked:bg-brand-primary peer-checked:before:left-[17px] dark:before:bg-black' />
    </label>
  );
}

export default ButtonCheckbox;
